import {
  Component,
  computed,
  input,
  output,
} from '@angular/core'
import { EntityType, EntityTypeCode, EntityTypeMap } from './entity-metadata'
import { sortBy } from 'lodash'
import { EditableTableToolbarButtonComponent } from './editable-table-toolbar-button.component'

@Component({
  selector: 'div[app-entity-mgmt-toolbar]',
  imports: [
    EditableTableToolbarButtonComponent,
  ],
  template: `
    <select class='form-select me-2' (change)="onChange($event)" [disabled]="!ready()">
      @for (t of entityTypes(); track t.entity_type_code) {
        <option [value]="t.entity_type_code" [selected]="t.entity_type_code === entityType()">
          {{ t.entity_type_code }} ({{ t.entity_type_name }})
        </option>
      }
    </select>
    <button
        btnType='success'
        app-editable-table-toolbar-button
        icon='add'
        [disabled]="!ready() || path() === 'new'"
        [title]="newButtonTitle()"
        (click)="createNew.emit()"
    >
    </button>
  `,
  host: {
    class: 'mt-2 mb-3',
  },
  styles: `
    :host {
      display: flex;
      align-items: flex-start;

      .form-select {
        min-width: 250px;
        width: auto;
      }
    }
  `,
})
export class EntityManagementToolbarComponent {
  readonly entityTypeMap = input.required<EntityTypeMap | undefined>()
  readonly entityType = input.required<EntityTypeCode | undefined>()
  readonly path = input.required<string>()

  readonly ready = computed(() => Boolean(this.entityType() && this.entityTypeMap()))

  protected entityTypes = computed<readonly EntityType[]>(() => {
    if (this.ready()) {
      return sortBy(
        Object.values(this.entityTypeMap()!).map(({ entity_type_code, entity_type_name }) => ({
          entity_type_code,
          entity_type_name,
        })),
        'entity_type_code',
      )
    } else {
      return []
    }
  })

  protected newButtonTitle = computed((): string => {
    const title = 'Create new'
    const selected = this.entityType()
    return selected ? `${title} ${selected}` : title
  })

  readonly entityTypeChange = output<EntityTypeCode>()
  readonly createNew = output()

  protected onChange({ target }: Event) {
    const type = (target as HTMLSelectElement).value as EntityTypeCode
    this.entityTypeChange.emit(type)
  }
}
